const listRegisterLivestreamManagementStyle = () => ({
    room: {
        border: '1px solid',
        borderRadius: '13px',
    },
    titleDetail: {
        paddingTop: '15px',
    },
    customTable: {
        maxHeight: '400px',
    },
    invoiceNumber: {
        textAlign: 'end',
        paddingRight: '25px',
    },
    totalPrice: {
        paddingLeft: '25px',
    },
    buttonExit: {
        marginBottom: '50px',
    },
    preView: {
        width: '100%',
        backgroundColor: (props) => props?.eventInfo?.settings_colors_viewer?.screen_background_color || '#fff',
        paddingBottom: '70px',
    },
});

export default listRegisterLivestreamManagementStyle;
